var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "table",
    { staticClass: "table", style: _vm.cssVars },
    [
      _vm._m(0),
      _vm.hasBeforeTotalFreeLines
        ? _c("tr", { staticClass: "bt" }, [
            _c(
              "td",
              { attrs: { colspan: "5" } },
              _vm._l(_vm.beforeFreeLines, function (line, i) {
                return _c("app-free-line", {
                  key: i,
                  attrs: { line: line, lang: _vm.lang, layout: _vm.layout },
                })
              }),
              1
            ),
          ])
        : _vm._e(),
      _vm.layout.Payments.Placement == "AfterDetail"
        ? _c("tr", { staticClass: "bt" }, [
            _c(
              "td",
              { attrs: { colspan: "5" } },
              [
                _c("app-payments", {
                  attrs: { lang: _vm.lang, layout: _vm.layout },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      !_vm.totals.HideAll
        ? [
            !_vm.totals.HideToPrintMessage
              ? _c(
                  "tr",
                  { staticClass: "bt defaultComment", style: _vm.trStyle },
                  [
                    _c("td", { attrs: { colspan: "5" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("common.print")) + " "),
                    ]),
                  ]
                )
              : _vm._e(),
            !_vm.totals.HideToPrintMessage
              ? _c(
                  "tr",
                  { staticClass: "bt defaultComment", style: _vm.trStyle },
                  [
                    _c("td", { attrs: { colspan: "5" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "components.sale-layout-editor.totals-preview.default-comment"
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            !_vm.totals.HideTotalLabels
              ? _c(
                  "tr",
                  { staticClass: "bt total-header", style: _vm.totalsStlye },
                  [
                    _c("td", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.totals.TotalExcVAT.getTranslation(_vm.lang)
                          ) +
                          " "
                      ),
                    ]),
                    _c("td", { staticClass: "w110 center-align" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.totals.TotalBase.getTranslation(_vm.lang)
                          ) +
                          " "
                      ),
                    ]),
                    _c("td", { staticClass: "w80 center-align" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.totals.VAT.getTranslation(_vm.lang)) +
                          " "
                      ),
                    ]),
                    _c("td", { staticClass: "w110 center-align" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.totals.TotalVAT.getTranslation(_vm.lang)) +
                          " "
                      ),
                    ]),
                    _c("td", { staticClass: "w110" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.totals.Total.getTranslation(_vm.lang)) +
                          " "
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            !_vm.totals.HideTotalValues
              ? _c(
                  "tr",
                  { staticClass: "bt totalContent", style: _vm.totalsStlye },
                  [
                    _c("td", { staticClass: "center-align" }, [_vm._v("0.00")]),
                    _c("td", { staticClass: "center-align" }, [_vm._v("0.00")]),
                    _c("td", { staticClass: "center-align" }, [_vm._v("21%")]),
                    _c("td", { staticClass: "center-align" }, [_vm._v("0.00")]),
                    _c("td", [_vm._v("0.00")]),
                  ]
                )
              : _vm._e(),
            !_vm.totals.HidePaymentBeforeDiscountConditions
              ? _c("tr", [
                  _c("td", { attrs: { colspan: "5" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.totals.PaymentBeforeDiscountDateConditions.getTranslation(
                            _vm.lang
                          )
                        ) +
                        " "
                    ),
                  ]),
                ])
              : _vm._e(),
            !_vm.totals.HideLeftToPay
              ? _c(
                  "tr",
                  {
                    staticClass: "bt bb pay-before",
                    style: _vm.toPayBeforeStyle,
                  },
                  [
                    _c(
                      "td",
                      { staticClass: "right-align", attrs: { colspan: "4" } },
                      [
                        !_vm.totals.Hidden
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.totals.TotalToPayBefore.getTranslation(
                                      _vm.lang
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("td", { staticClass: "right-align" }, [_vm._v("0.00")]),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _c("tr", [
        _c(
          "td",
          { attrs: { colspan: "5" } },
          _vm._l(_vm.totalsFreeLines, function (line, i) {
            return _c("app-free-line", {
              key: i,
              attrs: { line: line, lang: _vm.lang, layout: _vm.layout },
            })
          }),
          1
        ),
      ]),
      _vm.layout.Payments.Placement == "Totals"
        ? _c("tr", { staticClass: "bt" }, [
            _c(
              "td",
              { attrs: { colspan: "5" } },
              [
                _c("app-payments", {
                  attrs: { lang: _vm.lang, layout: _vm.layout },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("tr", { staticClass: "copyright" }, [
      _c("td", { attrs: { colspan: "5" } }, [_vm._v("© WinFakt!")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }